import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@wfp-common/auth/AuthContext';

interface ProtectedLoginProps {
    children?: React.ReactNode;
}

export const ProtectedLogin: FC<ProtectedLoginProps> = ({ children }) => {
    const { isUserLogged, appHomePath, isPathOnProtectedLocation } = useAuthContext();

    if (isUserLogged && !isPathOnProtectedLocation) {
        return <Navigate to={appHomePath} />;
    }

    if (!isUserLogged && isPathOnProtectedLocation) {
        // AuthContextProvider handles the redirect to Authentik.
        // Don't render children (app layout) to avoid UI flash.
        return null;
    }

    return <>{children}</>;
};

export default ProtectedLogin;
